import { render, staticRenderFns } from "./PassiveHelpButton.vue?vue&type=template&id=05ee6b39&scoped=true&"
var script = {}
import style0 from "./PassiveHelpButton.vue?vue&type=style&index=0&id=05ee6b39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ee6b39",
  null
  
)

export default component.exports